<sc-padding>
  <sc-flex stretchContent>
    <sc-flex-fitting-content>
      <sc-scroll-pane>
        <div *ngIf="layoutDefinition != null && transport">

          <app-transport-details [mode]="TransportDetailMode.READONLY" [layout]="layoutDefinition"
            [transport]="transport">

          </app-transport-details>
          <sc-content-spacer vertical></sc-content-spacer>
          <sc-flex class="messages">
            <ng-container *ngFor="let mk of station.stationUsage.messageKeys; let i = index">
              <sc-content-spacer *ngIf="i > 0"></sc-content-spacer>
              <div class="warning">
                <div class="visual">
                  <sc-dictionary-label [dictionaryKey]="mk"></sc-dictionary-label>
                </div>
              </div>
            </ng-container>
          </sc-flex>
        </div>
      </sc-scroll-pane>
    </sc-flex-fitting-content>
    <sc-content-spacer></sc-content-spacer>
    <div class="actionlist">
      <sc-flex vertical>

        <app-transport-details-dialog-action [transport]="transport"
          [disabled]="!station.stationUsage.transportDetailsAllowed" [asButton]="true"
          [dashboardContext]="dashboardContext" (onChange)="handleChange()">
        </app-transport-details-dialog-action>
        <sc-content-spacer vertical></sc-content-spacer>
        <app-link-transport-dialog-action [transportId]="transport?.id"
          [disabled]="!station.stationUsage.linkTransportsAllowed" [asButton]="true" (onChange)="handleChange()">
        </app-link-transport-dialog-action>
        <sc-content-spacer vertical></sc-content-spacer>
        <app-attach-detach-transport-dialog-action [transport]="transport" [asButton]="true" [disabled]="transport.processing.hasMovementOrder" (onChange)="handleChange()">
        </app-attach-detach-transport-dialog-action>
        <sc-content-spacer vertical></sc-content-spacer>
        <app-resend-message-action [transport]="transport" [station]="station"
          [disabled]="!station.stationUsage.sendMessageAllowed" [asButton]="true">
        </app-resend-message-action>

      </sc-flex>
    </div>
  </sc-flex>
</sc-padding>



<app-station-transport-action-bar [setProcessingStatusModel]="station.stationUsage.processingStatusModel"
  [setProcessingStatusModelValue]="station.stationUsage.processingStatusModelValue" [station]="station"
  [stationSet]="stationSet" [transport]="transport" [sacClientContext]="sacClientContext">
</app-station-transport-action-bar>
